import { FormElems } from '../../components/';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change, FieldArray } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'rc-tooltip/assets/bootstrap_white.css';
import {
    amountRange,
} from './constants.js';

import './PaymentPageTab.scss';
import { trim } from 'lodash';
import {
    createPaymentPageRequest,
    updatePaymentPageDetailsRequest,
} from '../../containers/PaymentPage/redux/paymentPage.actions';
import validate from './validator';
import moment from 'moment';
import DateTimePicker from 'components/DateTimePicker/DateTimePicker';
import PreviewModal from './PreviewModal';

import RenderUserDefineFields from './RenderUserDefineFields';

const PaymentPageTab = ({
    handleSubmit,
    auth,
    actions,
    history,
    formData = {},
    change,
    paymentPageData,
}) => {
    const { location } = history;
    const isEditMode = location.pathname.includes('edit') && !location.pathname.includes('new');
    const isDuplicate = location.pathname.includes('new');
    const { paymentPageEditData } = paymentPageData;
    const [isPreview, setIsPreview] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [desc, setDesc] = useState(paymentPageEditData?.templates?.systemDefineFields[1]?.defaultValue ?? '');
    const [showAdditionalSettings, setShowAdditionalSettings] = useState(true);
    const [status, setStatus] = useState('');
    const [descError, setDescError] = useState('');
    const [linkData, setLinkData] = useState({});
    const [dateOfPaymentPage, setDateOfPaymentPage] = useState(null);
    const [changeAmountTypeCount, setChangeAmountTypeCount] = useState(0);
    const [errorMsg, setErrorMsg] = useState("");

    const validateErrorMsg = (val) => {
        if (val.length >= 200) {
            setErrorMsg("Max 200 characters allowed.");
        } else {
            setErrorMsg("");
        }
    };

    const toggleAdditionalSettings = () => {
        setShowAdditionalSettings(!showAdditionalSettings);
    };

    const handlePreviewClick = values => {
        setIsPreview(true);
    };

    const handleSuccessClick = data => {
        history.push({
            pathname: '/payment-page',  // Change this to your actual listing page route
            state: { showSuccessModal: true, successData: data }
        });
    };
    

    const handleFormSubmit = values => {
        if (!desc) {
            return;
        }
        setDescError("");
        const userDefineFields = values.userDefineFields
            .filter(item => item.name)
            .map(item => {
                const obj = {
                    ...item,
                    validators: Array.isArray(item.validators)
                        ? item.validators
                        : [item.validators],
                    label:
                        item.name.charAt(0).toUpperCase() +
                        item.name.slice(1).toLowerCase(),
                    name: item.name.charAt(0).toUpperCase() +
                        item.name.slice(1).toLowerCase(),
                    placeholder: `Enter ${item.name.toLowerCase()}`,
                };
                return obj;
            });
        let amount = values.amount !== undefined && values.amount !== null
            ? Number(values.amount)
            : Number(values.minAmount);

        if (values.amountType == "VARIABLE") {
            amount = Number(values.minAmount);
        }
        if (values.amountType == 'USER_INPUT') {
            amount = null;
        }

        const request = {
            amount: amount,
            amountType: values.amountType,
            minAmount: values.amountType === "USER_INPUT" ? null : Number(values.minAmount || values.amount),
            maxAmount: values.amountType === "USER_INPUT" ? null : Number(values.maxAmount || values.amount),
            status,
            callBackUrl: values.callBackUrl || null,
            validityPeriod: moment(values.validityPeriod).format("YYYY-MM-DD HH:mm:ss"),
            templates: {
                systemDefineFields: [
                    {
                        name: 'purpose',
                        label: 'Purpose',
                        type: 'text',
                        defaultValue: values.purpose || '',
                        validators: ['required'],
                        placeholder: 'Enter Purpose',
                    },
                    {
                        name: 'description',
                        label: 'Description',
                        type: 'text',
                        defaultValue: desc || '',
                        validators: ['required'],
                        placeholder: 'Enter Description',
                    },
                ],
                userDefineFields,
            },
        };
        if (!isEditMode) {
            actions.createPaymentPageRequest(
                request,
                handleSuccessClick,
                status,
                history
            );
        }
        if (isEditMode) {
            const updatedRequest = {
                ...request,
                formId: paymentPageEditData?.formId,
                templateId: paymentPageEditData?.templateId.toString(),
            };
            actions.updatePaymentPageDetailsRequest(
                updatedRequest,
                history,
                status,
                handleSuccessClick
            );
        }
    };
    const quillRef = useRef(null); 

    useEffect(() => {
        if (quillRef.current) {
            const editor = quillRef.current.getEditor();

            editor.on("text-change", () => {
                const text = editor.getText().trim();
                console.log("text.length:", text.length);

                if (text.length > 1500) {
                    setDescError("Max 1500 characters allowed."); // ✅ Error दिखाओ
                    editor.deleteText(1500, editor.getLength()); // ✅ Extra characters हटाओ
                } else {
                    if (descError) {
                        setTimeout(() => setDescError(""), 2000); // ✅ Error 2 sec में hide होगा
                    }
                }

                setDesc(editor.root.innerHTML);
            });
        }
    }, [desc, descError]);

    const handleChange = (content) => {
        setDesc(content);
    };

    useEffect(() => {
        if (!formData.initial?.userDefineFields) {
            change('userDefineFields', [{}]);
        }
    }, [formData.initial]);

    useEffect(() => {
        if (changeAmountTypeCount) {
            change("amount", null);
            change("minAmount", null);
            change("maxAmount", null);
        }
    }, [changeAmountTypeCount]);

    useEffect(() => {
        if (paymentPageEditData && paymentPageEditData.templates) {
            const purpose = paymentPageEditData?.templates?.systemDefineFields[0]?.defaultValue;
            const desc = paymentPageEditData?.templates?.systemDefineFields[1]?.defaultValue;
            const amountType = paymentPageEditData?.amountType;
            const validityPeriod = paymentPageEditData?.validityPeriod;
            const validity = moment(validityPeriod).seconds(0).toDate();
            console.log("🚀 ~ useEffect ~ validity:", validity)
            const callBackUrl = paymentPageEditData?.callBackUrl;
            const userDefineFields = paymentPageEditData?.templates?.userDefineFields;
            if (userDefineFields?.length === 0) {
                change('userDefineFields', [{}]);
            } else {
                change('userDefineFields', paymentPageEditData?.templates?.userDefineFields);
            }
            if (amountType === 'FIXED') {
                const amount = paymentPageEditData?.amount;
                change('amount', amount);
            }
            else if (amountType === 'VARIABLE') {
                change('minAmount', paymentPageEditData?.minAmount);
                change('maxAmount', paymentPageEditData?.maxAmount);
            }
            change('purpose', purpose);
            setDesc(desc);
            change('amountType', amountType);
            change("validityPeriod", "");
            setDateOfPaymentPage("");
            change('callBackUrl', callBackUrl);
        }
    }, [paymentPageEditData]);
    return (
        <div className="merchant-tab">
            <form
                className="payment-page-detail-form"
                onSubmit={handleSubmit(handleFormSubmit)}
            >
                <h2 className="tab-title">Payment Page Details</h2>
                <div className="top-section">
                    <div className="left-side">
                        <div className="form-section purpose">
                            <div className="form-field">
                                <p className="label">
                                    Purpose
                                    <span className="required-asterisk">*</span>
                                </p>
                                <Field
                                    name="purpose"
                                    type="textarea"
                                    component={FormElems.TextArea}
                                    placeholder="Enter Purpose"
                                    maxlength={200}
                                    onChange={validateErrorMsg}
                                />
                                {errorMsg && <span className='errorMsg'>{errorMsg}</span>}
                            </div>
                        </div>
                        <div className="form-section amount-range">
                            <div className="amountRange">
                                <div className="form-field">
                                    <p className="label">
                                        Amount Type
                                        <span className="required-asterisk">*</span>
                                    </p>
                                    <Field
                                        name="amountType"
                                        placeholder="Amount Type"
                                        id="amount-type"
                                        data={amountRange || []}
                                        labelField="name"
                                        valueField="value"
                                        component={FormElems.Select}
                                        label="Select Amount Type"
                                        onChange={() => { setChangeAmountTypeCount(prev => prev + 1) }}
                                    />
                                </div>

                                {(() => {
                                    const selectedAmountType = formData?.values?.amountType || paymentPageEditData?.amountType;

                                    if (selectedAmountType === 'FIXED') {
                                        return (
                                            <div className="form-field">
                                                <p className="label">
                                                    Amount
                                                    <span className="required-asterisk">*</span>
                                                </p>
                                                <Field
                                                    name="amount"
                                                    placeholder="Amount"
                                                    id="amount"
                                                    component={FormElems.Input}
                                                    label="Enter Amount"
                                                    type="number"
                                                    parse={value => (value && value < 0 ? 0 : value)}
                                                />
                                            </div>
                                        );
                                    }

                                    if (selectedAmountType === 'VARIABLE') {
                                        return (
                                            <>
                                                <div className="form-field">
                                                    <p className="label">
                                                        Minimum Amount
                                                        <span className="required-asterisk">*</span>
                                                    </p>
                                                    <Field
                                                        name="minAmount"
                                                        placeholder="Enter Minimum Amount"
                                                        component={FormElems.Input}
                                                        type="number"
                                                        parse={value => (value && value < 0 ? 0 : value)}
                                                    />
                                                </div>
                                                <div className="form-field">
                                                    <p className="label">
                                                        Maximum Amount
                                                        <span className="required-asterisk">*</span>
                                                    </p>
                                                    <Field
                                                        name="maxAmount"
                                                        placeholder="Enter Maximum Amount"
                                                        component={FormElems.Input}
                                                        type="number"
                                                        parse={value => (value && value < 0 ? 0 : value)}
                                                    />
                                                </div>
                                            </>
                                        );
                                    }

                                    return null;
                                })()}
                            </div>

                        </div>
                    </div>
                    <div className="right-side">
                        <div className="form-section desc">
                            <div className="form-field">
                                <p className="label">
                                    Description
                                    <span className="required-asterisk">*</span>
                                </p>
                                <ReactQuill
                                    ref={quillRef}
                                    value={desc}
                                    theme="snow"
                                    placeholder="Write Description"
                                    onChange={handleChange}
                                />
                                <p className={'custom-error-message'}>
                                    {descError}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom-section">
                    <div className="additionalSettings">
                        <div className={'wrapper-container'}>
                        </div>

                        <div className="additional-settings-container">
                            <div className="form-field">
                                <p className="label">
                                    Validity
                                    <span className="required-asterisk">*</span>
                                </p>
                                <Field
                                    name="validityPeriod"
                                    component={DateTimePicker}
                                    selectedDate={dateOfPaymentPage}
                                    onSetDateTime={(selectedDate) => {
                                        setDateOfPaymentPage(selectedDate);
                                    }}
                                    placeholder="Select Validity Date"
                                    minDate={new Date()}
                                    disabledKeyboardNavigation
                                    onKeyDown={(e) => e.preventDefault()}
                                    showTimeSelect
                                    timeFormat="HH:mm:00"
                                    timeIntervals={30}
                                    timeCaption="Time"
                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                />
                            </div>
                            <div className="form-field">
                                <p className="label">Callback URL</p>
                                <Field
                                    name="callBackUrl"
                                    type="text"
                                    component={FormElems.Input}
                                    placeholder="Enter Callback URL"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <p className={'custom-level with-line'}>
                            Do you want consumer to give some details?
                            <span>(optional)</span>
                        </p>
                        <FieldArray
                            name="userDefineFields"
                            component={RenderUserDefineFields}
                        />
                    </div>
                </div>
                <div className="form-section action">
                    <FormElems.Button
                        buttonType="secondary"
                        text="Preview"
                        type="button"
                        handleClick={() => {
                            handleSubmit(handlePreviewClick)();
                            if (!desc) {
                                setDescError('Please enter description.');
                                return;
                            }
                        }}
                    />

                    <FormElems.Button
                        id="next-btn"
                        buttonType="primary"
                        text={'Publish'}
                        handleClick={() => {
                            setStatus('ACTIVE');
                            setDescError('');
                            if (!trim(desc)) {
                                setDescError('Please enter description.');
                            }
                        }}
                    />
                    <FormElems.Button
                        id="draft-btn"
                        buttonType="draft"
                        text={'Save as Draft'}
                        handleClick={() => {
                            setStatus('DRAFT');
                            setDescError('');
                            if (!trim(desc)) {
                                setDescError('Please enter description.');
                            }
                        }}
                    />
                </div>
            </form>

            {isPreview && (
                <PreviewModal
                    fields={formData.values?.userDefineFields || []}
                    amountType={formData.values?.amountType}
                    amount={formData.values?.amount}
                    minAmount={formData.values?.minAmount}
                    maxAmount={formData.values?.maxAmount}
                    onClose={() => setIsPreview(false)}
                    formData={formData}
                    desc={desc}
                    auth={auth}
                />
            )}
            {/* {isSuccess && (
                <SuccessModal
                    formLinkData={linkData}
                    onClose={() => setIsPreview(false)}
                />
            )} */}
        </div>
    );
};

PaymentPageTab.propTypes = {
    actions: PropTypes.object,
    merchantData: PropTypes.object.isRequired,
    auth: PropTypes.object,
    change: PropTypes.func,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    previousPath: PropTypes.string,
    sectionType: PropTypes.string,
    name: PropTypes.string,
    initialValues: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    formData: PropTypes.object,
    draftData: PropTypes.object,
};

const mapStateToProps = ({
    auth,
    form,
    editData,
    staticData,
    paymentPageData,
}) => ({
    auth,
    formData: form['add-payment-page-form'],
    editData,
    staticData,
    paymentPageData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            createPaymentPageRequest,
            updatePaymentPageDetailsRequest,
            change,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'add-payment-page-form',
            enableReinitialize: true,
            validate,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(PaymentPageTab)
);
